import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchCursusStages = (
  cursusId: string,
  setCursusStages: Function,
  setLoading: Function,
  language: string,
  setFetchError: Function,
  onSuccess?: Function
) => {
  if (!cursusId) return;
  setLoading(true);

  ApiService.get(`cursus/${cursusId}/stages?fetch_stages_flags=true`)
    .then((response) => {
      setCursusStages(response.data.cursus_stages);
      setFetchError(false);
      onSuccess?.();
    })
    .catch((error) => {
      setFetchError(true);
      console.error("Error fetching cursus stages:", error);
      alert(translate(language, "PAGES.COURSE.ERRORS.FETCH_STAGES"));
    })
    .finally(() => setLoading(false));
};
